// Helpers
import { apiInstance, gql } from "@/services/httpAdapter";
import { errorLogger } from "@Common/helpers/logger";

// Types
import { GraphqlQueryResponse } from "@Common/api/types/GraphqlQueryResponse";
import { IDraw, IOverdraw } from "@DataPages/types/draw/models";
import { Nullish } from "@Common/interfaces/types";

export async function getDraws(locationId: string, commissionCycleId: string, payPeriodId: string): Promise<Nullish<IDraw>> {
	const query = gql`
		query getDraws($locationId: String!, $commissionCycleId: String!, $payPeriodId: String!) {
			getDraws(locationId: $locationId, commissionCycleId: $commissionCycleId, payPeriodId: $payPeriodId) {
				_id
				locationId
				commissionCycleId
				payPeriodId
				draws {
					drawItems {
						drawType
						amount
					}
					user {
						_id
						fullName
						position
					}
				}
				createdAt
				updatedAt
			}
		}
	`;

	const variables = {
		commissionCycleId,
		locationId,
		payPeriodId,
	};

	try {
		const response: GraphqlQueryResponse<"getDraws", IDraw> = await apiInstance.post("/graphql", { query, variables });
		return response.data.data?.getDraws ?? null;
	} catch (err) {
		errorLogger(err as Error, { function: "getDraws", message: "Failed to fetch draws", variables });
		return null;
	}
}

export async function getOverdraws(locationId: string, commissionCycleId: string, payPeriodId: string): Promise<Nullish<IOverdraw>> {
	const query = gql`
		query getOverdraws($locationId: String!, $commissionCycleId: String!, $payPeriodId: String!) {
			getOverdraws(locationId: $locationId, commissionCycleId: $commissionCycleId, payPeriodId: $payPeriodId) {
				_id
				commissionCycleId
				payPeriodId
				locationId
				overdraws {
					_id
					employee {
						_id
						name
						position
					}
					overdraw
				}
			}
		}
	`;

	const variables = {
		commissionCycleId,
		locationId,
		payPeriodId,
	};

	try {
		const response: GraphqlQueryResponse<"getOverdraws", IOverdraw> = await apiInstance.post("/graphql", { query, variables });
		return response.data.data?.getOverdraws ?? null;
	} catch (err) {
		errorLogger(err as Error, { function: "getOverdraws", message: "Failed to fetch overdraws", variables });
		return null;
	}
}
